import React from "react";
import { Box, Flex, FlexItem, createStyledComponent } from "mineral-ui";
import MaxWidth from "./MaxWidth";
import Link from "./Link";

const HeaderLink = createStyledComponent(Link, ({ theme }) => ({
  color: theme.color_white,
  ":hover": {
    color: theme.color_theme_20,
  },
}));

const HeaderBox = createStyledComponent(Box, ({ theme }) => ({
  backgroundColor: theme.color_gray_90,
  color: theme.color_white,
}));

const Header = ({ data: { viewer } }) => (
  <HeaderBox element="header" paddingVertical="sm">
    <MaxWidth>
      <Flex>
        <FlexItem>
          <HeaderLink to="/">
            <span className="home-icon fa fa-home" /> Home
          </HeaderLink>
        </FlexItem>
        <FlexItem>
          <HeaderLink to="/validate">
            <span className="home-icon fa fa-check" /> Validate license
          </HeaderLink>
        </FlexItem>

        <FlexItem grow={1} />

        <FlexItem>
          <HeaderLink href="https://graphile.org">
            Return to Graphile.org
          </HeaderLink>
        </FlexItem>
        {viewer ? (
          <FlexItem>
            <HeaderLink to="/settings">Settings</HeaderLink>
          </FlexItem>
        ) : null}
        {viewer ? (
          <FlexItem>
            <HeaderLink href="/logout">Sign out</HeaderLink>
          </FlexItem>
        ) : null}
        {viewer ? null : (
          <FlexItem>
            <HeaderLink to="/login">Log in</HeaderLink>
          </FlexItem>
        )}
      </Flex>
    </MaxWidth>
  </HeaderBox>
);

export default Header;
